import { useSelector } from 'react-redux';
import { withRouter } from 'react-router5';

import { selectCurrentUser } from '../redux/user/userSlice';
import routes from '../router/routes'

import './style/profile-bar.css'
import {useTranslation} from "react-i18next";

import useSubscribeRouter from "../utils/useSubscribeRouter";


const ProfileBar = ({ router, portal_ref }) => {
  const { user } = useSelector(selectCurrentUser);
  const {t} = useTranslation();

  const { route } = useSubscribeRouter(router);
  const {name: route_name} = route;

  const defined_route = routes.find(r => r.name === route_name);


  function goBack() {
    window.history.back();
  }

  const routes_no_goback = ['postfeed', 'profile.focus', 'profile.bookmark', 'carto','trending', 'editor'].concat([
    // explore main tabs are top routes
    'explore', 'explore.contacts', 'explore.entities', 'explore.themes', 'explore.content'
  ]);


  let arrow;
  if (! routes_no_goback.includes(route_name)) {
    arrow = <div className="c-showedit_bar-back-icon" onClick={goBack}/>;
  }
  // better would be to allow the arrow to be defined externally...
  if (defined_route.back_route) {
    arrow = <div className="c-showedit_bar-back-icon" onClick={() => {
      const {name, params, opts} = defined_route.back_route(route.data);
      router.navigate(name, params, opts);
    }}/>;
  }

  // const title = (
  //   defined_route.title
  //   ? (defined_route.title instanceof Function ? defined_route.title(data) : defined_route.title)
  //   : defined_route.name
  // );

  return <div className="profile-bar">
    <div className={'page-title-container'}>
      { arrow }
      <div className="page-title">
        { t(defined_route.title) || t(defined_route.name) }
      </div>
    </div>
    <div id="profile-bar-portal" ref={portal_ref} />
    <div className={'page-title-container'}>
      <div onClick={()=>{router.navigate('IM')}} className={route_name==='IM'?'IM active' : 'IM'}></div>
      <div className="profile">
        {user.firstname} {user.lastname}
      </div>

      <img src={user.img} alt="profile" />
    </div>
  </div>
}


export default withRouter(ProfileBar);
